import { AmplitudeEvent } from "@analytics/Amplitude/AmplitudeEvents";

enum SystemErrorEvent {
    // Abstract/base error name
    SYSTEM_ERROR_EVENT = "system_error_event",

    // Specific errors
    UNKNOWN_GLOBAL_CLIENT = "unknown_global_client_error",
}

interface SystemErrorEventDetails {
    readonly eventCode?: string | number;
    readonly eventMessage?: string;
    readonly eventStackString?: string;
}

class AbstractSystemErrorEvent extends AmplitudeEvent {
    constructor(subError: SystemErrorEvent, errorDetails: SystemErrorEventDetails) {
        super(SystemErrorEvent.SYSTEM_ERROR_EVENT);
        this.props = { ...errorDetails };
    }
}

export class UnknownGlobalClientErrorEvent extends AbstractSystemErrorEvent {
    constructor(details: SystemErrorEventDetails) {
        super(SystemErrorEvent.UNKNOWN_GLOBAL_CLIENT, details);
    }
}
